export const exhaustiveCheck = (value: never): never => value;
